export default __webpack_public_path__ + "e2fdfdaf412356a45ac790beb13cf66a.png";